<ul class="register__pagination">
    <li *ngFor="let n of numSequence(dots); let i = index"
        [ngClass]="{'active-dot': active == i + 1 }"
    ></li>
</ul>
